/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components), {Tag, Social} = _components;
  if (!Social) _missingMdxReference("Social", true);
  if (!Tag) _missingMdxReference("Tag", true);
  return React.createElement(React.Fragment, null, React.createElement(Tag, {
    id: "nothingcreative"
  }), "\n", React.createElement(Tag, {
    id: "mandisahardtimes"
  }), "\n", React.createElement(Tag, {
    id: "theofficialcameltoe"
  }), "\n", React.createElement(Tag, {
    id: "visitknoxville"
  }), "\n", React.createElement(_components.p, null, "Nothing Creative began in Knoxville, TN as two friends that got together to review RPDR Untucked on camera and evolved into an unscripted satirical comedy show."), "\n", React.createElement(_components.p, null, "Follow Mandisa:"), "\n", React.createElement(Social, {
    to: "facebook",
    id: "mandisahardtimes"
  }), "\n", React.createElement(Social, {
    to: "instagram",
    id: "mandisahardtimes"
  }), "\n", React.createElement(_components.p, null, "email: ", React.createElement(_components.a, {
    href: "mailto:mandisahardtimes@gmail.com"
  }, "mandisahardtimes@gmail.com")), "\n", React.createElement(_components.p, null, "Follow Camel:"), "\n", React.createElement(Social, {
    to: "facebook",
    id: "theofficialcameltoe"
  }), "\n", React.createElement(Social, {
    to: "instagram",
    id: "theofficialcameltoe"
  }), "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "http://www.HannahVonStevens.com",
    rel: "nofollow"
  }, "www.HannahVonStevens.com")));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
